module.exports = __webpack_public_path__ + "static/media/ottawa-37.e0826313.jpg";